import { CommonModule } from "@angular/common";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { ButtonModule } from "@progress/kendo-angular-buttons";
import { ExcelModule, GridModule } from "@progress/kendo-angular-grid";
import { AppGridComponent } from "./appgrid.component";
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { InputsModule, SwitchModule } from "@progress/kendo-angular-inputs";
import { TextFilterComponent } from "./filters/textfilter.component";
import { DropDownListFilterComponent } from "./filters/dropdownlistfilter.component";
import { BooleanFilterComponent } from "./filters/booleanfilter.component";
import { ApiHttpService } from "src/app/services/api-http.service";
import { MessageHandlerService } from "src/app/services/message-handler.service";
import { ActivityTrackerService } from "src/app/services/activity-tracker.service";
import { ConfigService } from "src/app/services/config.service";
import { UserPermissionsService } from "src/app/services/user-permissions.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { AppGridClientService } from "./appgrid.service.client";
import { AppGridServerService } from "./appgrid.service.server";
import { PermissionsService } from "src/app/services/permissions.service";
import { ClickOutside } from "../../directives/click-outside.directive";
import { KendoDialogService } from "src/app/services/kendo-dialog.service";
import { PopupAnchorDirective } from "../../directives/popupanchar.directive";
import { DynamicDataGridComponent } from "../dynamic-data-grid/dynamic-data-grid.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";

@NgModule({
    imports: [
        CommonModule,
        GridModule,
        ExcelModule,
        ButtonModule,
        DialogsModule,
        InputsModule,
        FormsModule, 
        SwitchModule,
        ReactiveFormsModule,
        DropDownsModule
    ],
    declarations: [
        AppGridComponent,
        TextFilterComponent,
        DropDownListFilterComponent,
        BooleanFilterComponent,
        ClickOutside,
        PopupAnchorDirective,
        DynamicDataGridComponent
        
    ],
    providers: [
        ApiHttpService,
        MessageHandlerService,
        ActivityTrackerService,
        UserPermissionsService,
        LocalStorageService,
        KendoDialogService,
        AppGridClientService,
        AppGridServerService,
        PermissionsService
    ],
    exports: [AppGridComponent,ClickOutside,PopupAnchorDirective, DynamicDataGridComponent]
})
export class AppGridModule {}